import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { wordpressRoot } from '../../configFile';
import PageContent from './PageContent';

export default function Page() {

    const [page, setPage] = useState({})
    let { pageName } = useParams();
    const navigate = useNavigate()

    const fetchData = useCallback(async () => {
        if (!pageName)
            return

        const response = await fetch(wordpressRoot + 'wp-json/wp/v2/pages?slug=' + pageName);
        if (!response.ok) {
            console.error("While fetching")
            return navigate('/')
        }
        const pages = await response.json();
        if (!pages[0])
            return navigate('/')
        console.log(pages)
        setPage(pages[0])
    }, [pageName, navigate])
    
    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <div>
            <PageContent page={page} />
        </div>
        )
}
